import { render, staticRenderFns } from "./company-panel--supporter.vue?vue&type=template&id=8ccbae70&scoped=true&"
import script from "./company-panel--supporter.vue?vue&type=script&lang=ts&"
export * from "./company-panel--supporter.vue?vue&type=script&lang=ts&"
import style0 from "./company-panel--supporter.vue?vue&type=style&index=0&id=8ccbae70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccbae70",
  null
  
)

export default component.exports